import { Helmet } from '@dr.pogodin/react-helmet';
import { useApiRead } from 'api-read-hook';
import { subDays } from 'date-fns';
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { css, html } from 'react-strict-dom';

import {
  PageError,
  PageHeading,
  PageLoading,
  PageWrap,
} from '../../components';
import { useSelectedCompany } from '../../contexts/ClientDataContext';
import { Model } from '../../models';
import { formatAsDate, values } from '../../util';
import KpiTile from './KpiTile';
import RangeChoices from './RangeChoices';

export default function KpisPage() {
  const { companySlug } = useParams<{ companySlug: string }>();
  const selectedCompany = useSelectedCompany();

  const [fromDate, setFromDate] = React.useState(
    formatAsDate(subDays(new Date(), 30))
  );
  const [toDate, setToDate] = React.useState(formatAsDate(new Date()));

  const api = useApiRead<Record<string, Model.Kpi.View>>(
    `/company-data/${companySlug}/kpis/all/${fromDate}/${toDate}`
  );

  if (api.error) return <PageError {...api} />;

  const inner = api.data ? (
    <>
      {values(api.data).map((kpi) => (
        <KpiTile key={kpi.title} companySlug={companySlug!} kpi={kpi} />
      ))}
    </>
  ) : (
    <PageLoading />
  );

  return (
    <PageWrap>
      <Helmet>
        <title>{`KPI Dashboard | ${selectedCompany.name}`}</title>
      </Helmet>
      <PageHeading
        right={
          <RangeChoices
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
          />
        }
      >
        KPI Dashboard
      </PageHeading>
      <html.div style={styles.sectionMain}>
        <html.div style={styles.colMain}>{inner}</html.div>
      </html.div>
    </PageWrap>
  );
}

const styles = css.create({
  sectionMain: {
    display: {
      default: 'flex',
      '@media (max-width: 940px)': 'block',
    },
  },
  colMain: {
    display: 'flex',
    flex: 5,
    flexWrap: 'wrap',
  },
});
